import { Link, Navigate, useParams } from 'react-router-dom';
import { useContent } from '../ContentContext';
import { PageHero, SectionHead, PackGrid } from '../components/Common';

// Brand catalogue page — the full pack range grouped by category, matching the
// source site. Prices live on the shop (/products), not here.
const CATEGORIES = [
  { id: 'basmati', name: 'Premium Basmati Rice' },
  { id: 'biryani', name: 'Shahi Biryani Rice' },
  { id: 'rozana', name: 'Rozana Rice' },
];

export default function BrandPage() {
  const { slug } = useParams();
  const { brandBySlug } = useContent();

  const brand = brandBySlug(slug);
  if (!brand) return <Navigate to="/" replace />;

  const groups = CATEGORIES
    .map((c) => ({ cat: c, codes: brand.products?.[c.id] || [] }))
    .filter((g) => g.codes.length);

  return (
    <>
      <PageHero title={brand.name} image={brand.image} />

      <section>
        <div className="container">
          <SectionHead
            tag="Premium Collection"
            title={brand.heroTitle || `${brand.name} — Premium Quality Rice Collection`}
            text="Swaad Aur Sehat Ka Raaz"
          />
          {!groups.length ? <p className="muted">No products available yet.</p> : null}
        </div>
      </section>

      {groups.map((g, i) => (
        <section key={g.cat.id} id={g.cat.id} className={i % 2 === 0 ? 'alt-bg' : ''}>
          <div className="container">
            <SectionHead title={g.cat.name} />
            <PackGrid brand={brand} category={g.cat.id} codes={g.codes} />
          </div>
        </section>
      ))}

      <section className="grey-bg">
        <div className="container" style={{ textAlign: 'center' }}>
          <SectionHead title="Want to buy online?" text="See live prices and order for delivery." />
          <Link className="consult-btn" to="/products" style={{ display: 'inline-flex' }}>
            <i className="fas fa-cart-shopping" /> Shop All Products
          </Link>
        </div>
      </section>
    </>
  );
}
